import React, { useState } from "react";
import { useGetPendingJivoQuery, useConfirmJivoMutation } from "../store/api";

export const AdminJivo: React.FC = () => {
    const [codes, setCodes] = useState<{ [key: number]: string }>({});

    // Загрузка регистраций
    const { data: jivoResponse, isLoading } = useGetPendingJivoQuery(
        undefined,
        {
            pollingInterval: 30000,
        }
    );

    const registrations = (jivoResponse as any)?.data?.registrations || [];

    // Мутация подтверждения
    const [confirmJivoFn, { isLoading: isConfirming }] =
        useConfirmJivoMutation();

    const handleConfirm = async (jivoId: number) => {
        const code = codes[jivoId] || "";
        if (!code.trim()) {
            alert("Введите код чата");
            return;
        }

        try {
            await confirmJivoFn({
                jivo_id: jivoId,
                code: code.trim(),
            }).unwrap();
            alert("Регистрация подтверждена");
            setCodes({});
        } catch (error: any) {
            alert("Ошибка: " + (error.data?.message || error.message));
        }
    };

    const formatDate = (dateString: string) => {
        return new Date(dateString).toLocaleString("ru-RU");
    };

    if (isLoading) {
        return <div className="p-6">Загрузка...</div>;
    }

    return (
        <div className="p-6 space-y-6">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                Jivo регистрации
            </h1>

            {registrations && registrations.length > 0 ? (
                <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                            <thead className="bg-gray-50 dark:bg-gray-900">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                        ID
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                        Имя
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                        Телефон
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                        Страна
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                        Email
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                        Пароль
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                        Дата
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                        Код чата
                                    </th>
                                    <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                                        Действие
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                                {registrations.map((reg: any) => (
                                    <tr key={reg.id}>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                                            {reg.user_id}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                                            {reg.surname} {reg.name}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                                            {reg.phone}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                                            {reg.country}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                                            {reg.email}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white font-mono">
                                            {reg.password}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                                            {formatDate(reg.time)}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <input
                                                type="text"
                                                value={codes[reg.id] || ""}
                                                onChange={(e) =>
                                                    setCodes({
                                                        ...codes,
                                                        [reg.id]:
                                                            e.target.value,
                                                    })
                                                }
                                                className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-1 w-32 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                                                placeholder="Код чата"
                                            />
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-center">
                                            <button
                                                onClick={() =>
                                                    handleConfirm(reg.id)
                                                }
                                                disabled={isConfirming}
                                                className="bg-green-600 hover:bg-green-700 text-white px-4 py-1 rounded-md text-xs disabled:opacity-50"
                                            >
                                                Готово
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : (
                <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
                    <p className="text-center text-gray-500 dark:text-gray-400">
                        Нет ожидающих регистраций
                    </p>
                </div>
            )}
        </div>
    );
};
